import styled from 'styled-components';
import ZanHover from '@/images/customer/zan-hover.png';
import ZanOn from '@/images/customer/zan-on.png';
import PinglunHOver from '@/images/customer/lun-hover.png';
import MoreHover from '@/images/customer/more-hover.png';
import More from '@/images/customer/more.png';
import Pinglun from '@/images/customer/lun.png';
import Zan from '@/images/customer/zan.png';
interface CommentBottomDetailOptsWrapperProps {
  ref?: React.RefObject<HTMLDivElement>;
}
export const CommentBottomDetailOptsWrapper = styled.div<CommentBottomDetailOptsWrapperProps>`
  position: relative;
  height: 20px;
  border-radius: 4px;
  display: flex;
  justify-content: end;
  align-items: center;
  gap:16px;
  .btn {
    display: flex;
    color: #1A1A1A;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    cursor: pointer;
    align-items: center;
    &.active {
      .zanIcon {
        path {
          stroke: var(--sys-color-Primary700);
          fill:var(--sys-color-Primary700)
        }
      }
    }
    &:hover {
      &:not(.active) {
        color: var(--sys-color-Primary700);

        .zanIcon {
          svg,
          path {
            stroke: var(--sys-color-Primary700);
          }
        }

        .pinglunIcon {
          svg,
          path {
            fill: var(--sys-color-Primary700);
          }
        }

        .moreIcon {
          background: url('${MoreHover.src}') no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
  .zanIcon {
    background-size: 100% 100%;
    .space{
       margin-left:4px;
    }
  }

  .line {
    margin: 0 8px;
    width: 0;
    height: 12px;
    border-right: 1px solid rgba(224, 225, 229, 1);
  }
  .pinglunIcon {
    background-size: 100% 100%;
  }

  .moreIcon {
    width: 20px;
    height: 20px;
    background: url('${More.src}') no-repeat;
    background-size: 100% 100%;
  }

  .mar {
    margin-right: 5px;
  }
`;
